import { pipe } from 'ramda';
import { attributesToProps } from 'html-react-parser';
import { toCamelCase } from 'js/utils/string.util';

export const supportOnClickAttribute = (attribs = {}) => {
    const { onclick, onClick, ...rest } = attribs;

    if (!onclick && !onClick) {
        return { ...rest };
    }

    // eslint-disable-next-line no-new-func
    const fn = new Function('event', onclick || onClick);

    return { ...rest, onClick: fn };
};

export const parseHTMLAttributes = (attribs = {}) => {
    return Object.keys(attribs).reduce((result, key) => {
        const value = attribs[key] === 'true' ? true : attribs[key] === 'false' ? false : attribs[key];

        if (key.includes('_')) {
            result[toCamelCase(key)] = value;
        } else {
            result[key] = value;
        }

        return result;
    }, {});
};

export const alignAttributesWithReact = pipe(attributesToProps, supportOnClickAttribute);
